<div class="max-mobile:overflow-auto">
	<main
		class="p-16px bg-light-grey flex justify-evenly rounded-[24px] max-mobile:overflow-auto max-mobile:block min-w-[600px]"
	>
		<div
			(click)="
				activeStatus = +method.value; emitActiveStatus.emit(+method.value)
			"
			*ngFor="let method of financeStatus; let i = index"
			class="p-24px item mx-[5px] rounded-[24px] cursor-pointer  max-mobile:p-[6px] {{
				activeStatus == +method.value ? 'bg-gradient ' : 'bg-off-white'
			}} max-mobile:inline-block max-mobile:w-full max-mobile:max-w-[100px]"
		>
			<div
				class="p-[10px] max-mobile:p-[5px] bg-light-grey rounded-12px inline-block mb-12px max-mobile:mb-[6px]"
			>
				<img
					class="max-w-[24px] max-mobile:max-w-[12px]"
					[src]="imgPaths[+method.value - 1]"
					alt=""
				/>
			</div>
			<h1
				class=" {{
					activeStatus == +method.value ? 'text-off-white' : 'text-medium-gray'
				}}  text-font-14 mb-[3px] leading-22px max-mobile:text-[7px]"
			>
				{{ 'FINANCE.FINANCE_LIST.' + method.name.toUpperCase() | translate }}
			</h1>
			<h1
				class="   {{
					activeStatus == +method.value ? 'text-off-white' : 'text-dark-grey'
				}}   text-font-16 font-DIN-bold font-bold mb-0 max-mobile:text-[10px]"
			>
				<span>{{
					translate?.currentLang == 'en'
						? currency?.name.en
						: currency?.name?.ar
				}}</span>
				{{ totalsArray?.length ? totalsArray[i] : '' }}
			</h1>
		</div>
	</main>
</div>
